import { render } from "./IssuesLinkPanel.vue?vue&type=template&id=fa69eb98"
import script from "./IssuesLinkPanel.vue?vue&type=script&lang=js"
export * from "./IssuesLinkPanel.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__